/** EST3 cost line provenance — REUSE rate_source + source_ref_* + meta_json (no SCHEMA_GAP). */

export interface Est3CostProvenance {
  rateSource?: string;
  sourceRefType?: string;
  sourceRefId?: string;
  sourceRefLabel?: string;
  quoteDate?: string;
  validityDate?: string;
  meta?: Record<string, unknown> | null;
  summary: string;
}

function parseMeta(raw: unknown): Record<string, unknown> | null {
  if (raw == null) return null;
  if (typeof raw === 'object' && !Array.isArray(raw)) return raw as Record<string, unknown>;
  try {
    return JSON.parse(String(raw)) as Record<string, unknown>;
  } catch {
    return null;
  }
}

export function getEst3CostProvenance(row: Record<string, unknown>): Est3CostProvenance {
  const rateSource = String(row.rate_source || row.rateSource || '').trim() || undefined;
  const sourceRefType = String(row.source_ref_type || row.sourceRefType || '').trim() || undefined;
  const sourceRefId = String(row.source_ref_id || row.sourceRefId || '').trim() || undefined;
  const sourceRefLabel = String(row.source_ref_label || row.sourceRefLabel || '').trim() || undefined;
  const libraryTemplateId = String(
    row.source_library_cost_template_id || row.sourceLibraryCostTemplateId || ''
  ).trim();
  const quoteDate = row.quote_date || row.quoteDate;
  const validityDate = row.validity_date || row.validityDate;
  const meta = parseMeta(row.meta_json ?? row.metaJson);

  const parts: string[] = [];
  if (rateSource) parts.push(rateSource);
  if (sourceRefType === 'WBS_LIBRARY_TEMPLATE' || libraryTemplateId) {
    parts.push('WBS library');
  } else if (sourceRefLabel) {
    parts.push(sourceRefLabel);
  } else if (sourceRefType) {
    parts.push(sourceRefType);
  }
  if (quoteDate) parts.push(`quote ${String(quoteDate).slice(0, 10)}`);

  const importMeta = meta?.import as Record<string, unknown> | undefined;
  if (importMeta?.source) {
    parts.push(`import r${importMeta.row ?? '?'}`);
  }

  return {
    rateSource,
    sourceRefType,
    sourceRefId,
    sourceRefLabel,
    quoteDate: quoteDate ? String(quoteDate) : undefined,
    validityDate: validityDate ? String(validityDate) : undefined,
    meta,
    summary: parts.length ? parts.join(' · ') : '—',
  };
}
